export default __webpack_public_path__ + "static/media/frg--gymnasium.99a523a8.png";